module.exports = __webpack_public_path__ + "media/components/Influencers/Layouts/Navigation/homeIcon-f55ea8aa8e866a13154c23d268e16c4e.svg";